import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the window scroll position to the top whenever the route's pathname
 * changes. React Router preserves the previous scroll offset by default, which
 * means following an internal link from halfway down a long index page (e.g.
 * an ArticleCard on /pulse) lands the user halfway down the destination page
 * instead of at the article's title.
 *
 * If the new URL contains a hash (#anchor) we scroll the matching element
 * into view instead, so deep-links to anchors keep working.
 *
 * Mounted once near the top of the router tree; renders nothing.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const target = id ? document.getElementById(id) : null;
      if (target) {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        return;
      }
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
